import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => ({
  card: {
    '.ant-card-body': {
      padding: '16px 24px'
    }
  }
}))
